export default __webpack_public_path__ + "static/media/mocks.0901c8d8.jpg";